
///////////////////////////////////////////////////////////////////
/////  INTERACTIVE scatterplot
//////////////////////////////////////////////////////////////////

import * as d3 from "d3";

export default function scatterplot() {

    let data,
        chart,
        colors,
        tooltip,
        nTransitionsComplete,
        f,
        t,
        scatter,
        svg,
        g,
        clip,
        axisBottom,
        axisLeft,
        xAxis,
        yAxis,
        xAxisLabel,
        yAxisLabel,
        xAxisZero,
        yAxisZero,
        xExtent,
        yExtent,
        xScale,
        yScale,
        zeroAxis;

    let margin = { top: 30, right: 20, bottom: 50, left: 50 },
        w = 900 - margin.left - margin.right,
        h = 480 - margin.top - margin.bottom;

    //returned function takes a d3 selection as argument
    function exports(_selection) {

        //loops through this selection with d3.each
        _selection.each(function (data) {

            console.log("dot DATA :: ", data);
            // setDataMapping();
            nTransitionsComplete = 0;

            // data = randomData(300);
            tooltip = d3.select("body").append("div").attr("class", "toolTip");

            //CREATE CHART COMPONENT
            if (!chart) {

                console.log("dot DATA ::::::::: ", data, this)

            }

            let setFormat=()=>{
                f = d3.format("$,.1f");
            }

            let setTransition =()=>{
                t = d3.transition()
                    .duration(500)
                    .ease(d3.easeLinear);
            }

            let setColorRange=()=>{
                 colors=(n)=> {
                    let col = ["#92278f","#F7941E","#50B848","#00AED9"];
                    return col[n];
                 }
            }


            let setDataMapping=()=>{

                data.forEach(function(d){
                    // console.log("DDD ", d);
                    d.x = d.household;
                    d.y = d.growth;
                    d.quad = getQuad(d.x,d.y);
                    d.type = getType(d.geography,d.income)
                })
            }

            let setScales=()=>{

                xScale = d3.scaleLinear()
                    .range([0, w])
                    .nice();

                yScale = d3.scaleLinear()
                    .range([h, 0]);
            }

            let setDomains=()=>{
                xExtent = d3.extent(data, function (d) { return d.x; });
                yExtent = d3.extent(data, function (d) { return d.y; });
                xScale.domain(d3.extent(data, function (d) { return d.x; })).nice();
                yScale.domain(d3.extent(data, function (d) { return d.y; })).nice();
            }

            let setAxis=()=>{

                xAxis = d3.axisBottom(xScale)
                    .ticks(12)
                    .tickSize(-h);

                yAxis = d3.axisLeft(yScale)
                    .ticks(12 * h / w)
                    .tickSize(-w);

            }

            //CUSTOMIZE THE GRID TO BE MUTED AND DASHED
            let xCustomAxis=(g)=>{

                let s = g.selection ? g.selection() : g;

                g.call(xAxis);
                s.select(".domain").remove();
                s.selectAll(".tick line")
                    .attr("stroke", "#999")//SEPARATELY STYLES THE ZERO-AXIS
                    .filter(Number)//FILTERS ZERO-AXIS FROM OTHER TICK LINES at axis x values
                    .attr("stroke", "#e3e3e3")
                    .attr("stroke-dasharray","3,3");

            }

            let yCustomAxis=(g)=>{

                let s = g.selection ? g.selection() : g;

                g.call(yAxis);
                s.select(".domain").remove();
                s.selectAll(".tick line")
                    .attr("stroke", "#999")//SEPARATELY STYLES THE ZERO-AXIS
                    .filter(Number)//FILTERS ZERO-AXIS FROM OTHER TICK LINES at axis y values
                    .attr("stroke", "#e3e3e3")
                    .attr("stroke-dasharray","3,3");

            }

            let setAxisCustom=()=>{

                //BOTTOM AXIS LINE
                axisBottom = d3.axisBottom(xScale)
                    .tickSizeOuter(0)//REMOVES END TICKS
                    .ticks(0);

                //LEFT AXIS LINE
                axisLeft = d3.axisLeft(yScale)
                    .tickSizeOuter(0)//REMOVES END TICKS
                    .ticks(0);

            }

            let setAxisZero=()=>{

                //BOTTOM AXIS LINE
                xAxisZero= d3.axisBottom(xScale)
                    .tickSizeOuter(0)//REMOVES END TICKS
                    .ticks(0);

                //LEFT AXIS LINE
                yAxisZero= d3.axisLeft(yScale)
                    .tickSizeOuter(0)//REMOVES END TICKS
                    .ticks(0);

            }

            let drawChart=()=>{

                svg = d3.select("#scatterplot")
                    .append("svg")
                    .attr("width", w + margin.left + margin.right)
                    .attr("height", h + margin.top + margin.bottom)
                    .append("g")
                    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

                clip = svg
                    .append("defs")
                    .append("svg:clipPath")
                    .attr("id", "clip")
                    .append("svg:rect")
                    .attr("width", w )
                    .attr("height", h )
                    .attr("x", 0)
                    .attr("y", 0);

            }

            let drawAxis=()=>{

                //ADDS X-AXIS GRID LINES
                svg.append("g")
                    .attr("class", "x axis")
                    .attr("id", "axis--x")
                    .attr("transform", "translate(0," + h + ")")
                    .call(xCustomAxis)
                    .selectAll("text")
                    .style("text-anchor", "middle")
                    .attr("class", "axisTicks")
                    .attr("x",  -6)
                    .attr("dx", ".5em")
                    .attr("dy", "2em");

                //ADDS Y-AXIS GRID LINES
                svg.append("g")
                    .attr("class", "y axis")
                    .attr("id", "axis--y")
                    .call(yCustomAxis)
                    .selectAll("text")
                    .style("text-anchor", "middle")
                    .attr("class", "axisTicks")
                    .attr("dx", "-1.2em")
                    .attr("dy", ".5em");
            }

            let drawAxisCustom=()=>{
                //ADD BOTTOM AXIS
                svg.append("g")
                    .attr("class","axisBottom")
                    .attr("transform", "translate(0," + h + ")")
                    .call(axisBottom);

                //ADDS LEFT AXIS
                svg.append("g")
                    .attr("class","axisLeft")
                    .attr("transform", "translate(0,0)")
                    .call(axisLeft);
            }


            let drawAxisZero=()=>{
                //ADD BOTTOM AXIS
                svg.append("g")
                    .attr("class","xAxisZero")
                    .attr("transform", "translate(" + 0 +"," + yScale(zeroAxis.y) + ")")
                    .call(xAxisZero);

                //ADDS LEFT AXIS
                svg.append("g")
                    .attr("class","yAxisZero")
                    .attr("transform", "translate(" + xScale(zeroAxis.x) + "," + 0 +")")
                    .call(yAxisZero);
            }

            let drawDotPlot=()=>{
                scatter = svg.append("g")
                    .attr("id", "scatterplot")
                    .attr("clip-path", "url(#clip)");

                scatter.selectAll(".dot")
                    .data(data)
                    .enter().append("circle")
                    .attr("class", "dot")
                    .attr("r", 4)
                    .attr("cx", function (d) { return xScale(d.x); })
                    .attr("cy", function (d) { return yScale(d.y); })
                    .attr("opacity", 0.85)
                    .style("fill", function(d){
                        return colors(d.type)
                    })
                    .on("mouseover", function(d){ showTip(d); })
                    .on("mouseout", hideTip);
            }

            let drawAxisLabels=()=>{

                //X-LABEL
                svg.append("text")
                    .style("text-anchor", "middle")
                    .attr("class", "axisLabel")
                    .attr("x", w * .5)
                    .attr("y", h + 45)
                    .text(xAxisLabel);


                //Y-LABEL
                svg.append("text")
                    .attr("transform", "rotate(-90)")
                    .attr("class", "axisLabel")
                    .attr("x", -(h * .5))
                    .attr("y", -45)
                    .attr("dy", "1em")
                    .style("text-anchor", "middle")
                    .text(yAxisLabel);

            }

            setDataMapping();
            setFormat();
            setTransition();
            setColorRange();
            setScales();
            setDomains();
            setAxis();
            setAxisCustom();
            setAxisZero();
            drawChart();
            drawAxis()
            drawAxisCustom();
            drawAxisZero();
            drawDotPlot();
            drawAxisLabels();





            d3.selectAll("a[data-group]")
                .on("click", changeGroup);

            d3.selectAll("a[data-level]")
                .on("click", changeLevel);



        });//end fN(_selection.each)


    }//end fN(exports)


    //CALL FUNCTIONS

    function setDataMapping() {

        data.forEach(function(d){
            d.x = d.household;
            d.y = d.growth;
            d.quad = getQuad(d.x,d.y);
            d.type = getType(d.geography, d.income)
        })


    }

    // function randomData(samples) {
    //     let i,
    //         data = [],
    //         random = d3.randomNormal(),
    //         randomLevel = d3.randomUniform(0,4);
    //
    //     for (i = 0; i < samples; i++) {
    //
    //         let xVal = random();
    //         let yVal = random();
    //         let group = getGroup(xVal,yVal);
    //         let level = randomLevel();
    //
    //         data.push({
    //             x: xVal,
    //             y: yVal,
    //             group: group,
    //             level: parseInt(level)
    //         });
    //     }
    //     return data;
    // }

    function changeGroup(){

        let dataGroup =  +this.getAttribute("data-group");

        d3.selectAll(".dot")
            .transition(t)
            .style("opacity", function(d){
                    if(d.quad === dataGroup){
                        return 0.8;
                    }else{
                        if(dataGroup === 5) {
                            return 1;
                        }else{
                            return 0.25;
                        }
                    }
                });


    }

    function changeLevel(){

        let dataLevel =  +this.getAttribute("data-level") -1;

        d3.selectAll(".dot")
            .transition(t)
            .style("opacity", function(d){

                if(d.type === dataLevel){
                    return 0.8;
                }else{
                    return 0.25;
                }

            })

    }

    function getGroup(xVal, yVal){

        let group;
        if(xVal < 0 && yVal >= 0){
            group = 1;
        }else if(xVal >= 0 && yVal >= 0){
            group = 2;
        }else if(xVal < 0 && yVal < 0){
            group = 3;
        }else if(xVal >= 0 && yVal < 0){
            group = 4;
        }

        return group;
    }

    function getQuad(xVal, yVal){

        let quad;

        if(xVal < zeroAxis.household && yVal >= zeroAxis.growth){
            quad = 1;
        }else if(xVal >= zeroAxis.household && yVal >= zeroAxis.growth){
            quad = 2;
        }else if(xVal < zeroAxis.household && yVal < zeroAxis.growth){
            quad = 3;
        }else if(xVal >= zeroAxis.household && yVal < zeroAxis.growth){
            quad = 4;
        }

        return quad;
    }

    function getType(city, income){

        let type;

        if(city !== "China"){

            if (income <= 10000) {
                type = 2;
            }
            if (income > 10000 && income <= 50000) {
                type = 1;
            }
            if (income > 50000) {
                type = 0;
            }
        }else{
            type = 3
        }

        return type;
    }

    function showTip(d){
            let colorClass = "l" + String(d.type + 1);
           tooltip
              .style("left", d3.event.pageX + 5 + "px")
              .style("top",  d3.event.pageY - 125 + "px")
              .style("display", "inline-block")
              .style("opacity", 1)
              .html("<div class='toolTip-header " + colorClass + "'><h4>" + d.geography + "</h4>" +
                  "<h3 class='toolTip-header-kpi'>" + f(d.income) +
                  "</h3>" +
                  "<span class='toolTip-label'>Total Disposable Income (USD million)</span>" +
                  "</div>" +
                  "<div class='toolTip-content'>" +
                  "<small class='toolTip-kpi'>"+ f(d.household) + "</small>" +
                  "<span class='toolTip-label'>Household Income (USD)</span>" +
                  "<small class='toolTip-kpi'>" + d.growth + "%" + "</small>" +
                  "<span class='toolTip-label'>Income Growth</span>" +

                  "</div>"
              );

        // "<small>Household Income:"+ getGroupOpp(d) + "<br>Growth:" + getCityLevel(d) + "</small>");

    }


    function getGroupOpp(d){
        let message="";
        console.log(d);
        switch (d.quad){
            case 1:
                message = "Low Income, High Growth";
                break;
            case 2:
                message = "High Income, High Growth";
                break;
            case 3:
                message = "Low Income, Low Growth";
                break;
            case 4:
                message = "High Income, Low Growth";
                break;
        }
        return message;
    }

    function getCityLevel(d){
        let message="";
        switch (d.type){
            case 0:
                message = "Primary City";
                break;
            case 1:
                message = "Secondary City";
                break;
            case 2:
                message = "Tertiary City";
                break;
            case 3:
                message = "Country Average";
                break;
        }

        return message;
    }


    function hideTip(){

        console.log("HIDE");
        tooltip.style("display", "none");
    }


    //DRAW FUNCTIONS




    // function drawTooltip() {
    //     d3.selectAll("#pyramid_tooltip").remove();
    //
    //     ////ADD TOOLTIP
    //     tooltip = d3.select("body")
    //         .append("div")
    //         .attr({
    //             "id": "pyramid_tooltip",
    //             "class": "pytip"
    //         })
    //         .style("opacity", 0);
    //
    // }



    //GETTERS AND SETTERS
    exports.data = function (value) {
        if (!arguments.length)
            return data;

        data = value;
        console.log("dot DATA :::::::: ", data);


        return this;
    };

    exports.w = function (value) {
        if (!arguments.length) return w;
        w = value;
        return this;
    };


    exports.h = function (value) {
        if (!arguments.length) return h;
        h = value;
        return this;
    };


    exports.xAxisLabel = function (value) {
        if (!arguments.length) return w;

        xAxisLabel = value;

        return this;
    };


    exports.yAxisLabel = function (value) {
        if (!arguments.length) return h;

        yAxisLabel = value;

        return this;
    };


    exports.zeroAxis = function (value) {
        if (!arguments.length) return h;

        zeroAxis = value;

        return this;
    };

    // exports.isTransitionsComplete = function () {
    //     nTransitionsComplete++;
    //     dispatch.allTransitionsComplete();
    //
    // };
    //
    // exports.isAllTransitionsComplete = function () {
    //
    // };
    //


    // d3.rebind(exports, dispatch, "on");
    return exports;

};//end fN(scatterplot)






// WEBPACK FOOTER //
// ./src/app/emxd-charts/scatterplot/scatterplot.d3.js